import React from 'react';
import Alert from '@material-ui/lab/Alert';

export const TrimTwoStandingWarning: React.FC = () => (
  <Alert severity="warning" style={{ marginTop: 16 }}>
    Please ensure that all required options have been finalized during this
    phase!
  </Alert>
);
